import { render } from "./IziDialog.vue?vue&type=template&id=c64ae8d8"
import script from "./IziDialog.vue?vue&type=script&lang=ts"
export * from "./IziDialog.vue?vue&type=script&lang=ts"

import "./IziDialog.vue?vue&type=style&index=0&id=c64ae8d8&lang=scss"
script.render = render

export default script